import React from 'react';
import PropTypes from 'prop-types';
import { FormControl } from 'react-bootstrap';
import { map, pickBy } from 'lodash';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleLeft, faAngleDoubleRight } from '@fortawesome/pro-solid-svg-icons';

import SelectableRecordsTable from 'components/selectable_record_table/selectable_record_table';
import SelectableRow from 'components/selectable_record_table/selectable_row';

export default class FieldMapper extends React.Component {
  static propTypes = {
    csvMapping: PropTypes.object.isRequired,
    csvRows: PropTypes.arrayOf(PropTypes.array).isRequired,
    fieldFormat: PropTypes.object.isRequired,
    fileName: PropTypes.string.isRequired,
    headerRow: PropTypes.arrayOf(PropTypes.string).isRequired,
    onUpdateCsvMapping: PropTypes.func.isRequired
  }

  state = {
    rowIndex: 0
  }

  goToPrevRow = (e) => {
    e.preventDefault();

    this.setState(({ rowIndex }) => ({ rowIndex: rowIndex - 1 }));
  }

  goToNextRow = (e) => {
    e.preventDefault();

    this.setState(({ rowIndex }) => ({ rowIndex: rowIndex + 1 }));
  }

  unmappedFields = (buildoutField) => {
    const mappedFields = Object.values(this.props.csvMapping).filter(field => field != null);

    return pickBy(this.props.fieldFormat, (_, key) => !mappedFields.includes(key) || key === buildoutField);
  }

  handleUpdateCsvMapping = (e, importedField) => {
    const { value } = e.target;

    this.props.onUpdateCsvMapping(importedField, value.length > 0 ? value : null);
  }

  render() {
    return (
      <React.Fragment>
        <p>
          We found the following headers in your CSV. Please map them to Buildout by selecting the corresponding
          fields in the drop downs.&nbsp;
          <strong>Any unmatched fields will not be imported.</strong>
        </p>

        <h4 className="mt-5 text-uppercase text-muted">
          <strong>{this.props.fileName}</strong>
        </h4>
        <SelectableRecordsTable
          className="field-mapping-table mb-5"
          columnHeaders={this.renderColumnHeaders()}
          hasSelectAll={false}
          hasSelectColumn={false}
          name="csvMappingTable"
        >
          {this.props.headerRow.map((field, columnIndex) => this.renderCsvMappingRow(field, columnIndex))}
        </SelectableRecordsTable>
      </React.Fragment>
    );
  }

  renderColumnHeaders() {
    const { csvRows } = this.props;
    const { rowIndex } = this.state;

    const prevRow = (
      <React.Fragment>
        <FontAwesomeIcon className="mr-2" icon={faAngleDoubleLeft} />
        Prev
      </React.Fragment>
    );

    const nextRow = (
      <React.Fragment>
        Next
        <FontAwesomeIcon className="ml-2" icon={faAngleDoubleRight} />
      </React.Fragment>
    );

    return [
      <th key="column0">Buildout Field</th>,
      <th key="column1">Imported Field</th>,
      <th key="column2">Information Preview ({rowIndex + 1} of {csvRows.length})</th>,
      <th className="text-right" key="column3">
        {rowIndex < 1 ? (
          <span className="mr-4 text-muted">{prevRow}</span>
        ) : (
          <a className="mr-4" href="#" name="goToPrevRow" onClick={this.goToPrevRow}>{prevRow}</a>
        )}
        {rowIndex + 1 < csvRows.length ? (
          <a href="#" name="goToNextRow" onClick={this.goToNextRow}>{nextRow}</a>
        ) : (
          <span className="text-muted">{nextRow}</span>
        )}
      </th>,
    ];
  }

  renderCsvMappingRow(importedField, columnIndex) {
    const { csvRows, csvMapping } = this.props;
    const buildoutField = csvMapping[importedField];

    return (
      <SelectableRow hideCheckbox key={importedField}>
        <td>
          <FormControl
            className={buildoutField == null ? 'bg-warning' : ''}
            componentClass="select"
            name="buildoutFieldSelect"
            value={buildoutField || ''}
            onChange={e => this.handleUpdateCsvMapping(e, importedField)}
          >
            <option key="blank" value="">Select a field</option>
            {map(this.unmappedFields(buildoutField), (field, key) => (
              <option key={key} value={key}>{field.label || key}</option>
            ))}
          </FormControl>
        </td>
        <td name="importedField">
          <strong>{importedField}</strong>
        </td>
        <td name={`infoPreview${this.state.rowIndex}`}>
          {csvRows[this.state.rowIndex][columnIndex]}
        </td>
        <td />
      </SelectableRow>
    );
  }
}
